import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import FormBox from "../../commons/components/FormBox/FormBox";
import { AppContext } from "../../contexts/AppContext";
import ProductBulk from "./ProductBulk/ProductBulk";
import styles from "./styles.module.scss";
import ThresholdSetting from "./ThresholdSetting/ThresholdSetting";
import ProductBulkVariant from "./ProductBulkVariant/ProductBulkVariant";

const OrderSetting = () => {
  const { setCurrentStore, store, findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();

  useEffect(() => {
    if (!storeId || store.data.length === 0) return;
    findAndSetStore(storeId);
  }, [storeId, setCurrentStore, store]);

  return (
    <div className={styles.wrapper}>
      <FormBox title={<></>}>
        {storeId && (
          <>
            <ThresholdSetting storeId={storeId} />
          </>
        )}
      </FormBox>
    </div>
    // </Form>
  );
};

export default OrderSetting;
